import BatchesPanel from "./BatchesPanel";

export default BatchesPanel;